import hasStatisticsCookieConsent from './cookieConsent';

const logEvent = (eventName, attributes) => {
  if (hasStatisticsCookieConsent()) {
    window.datadogRum?.addAction(eventName, attributes);
  }
};
export default logEvent;
